import React from "react";
import styled from "styled-components";

import { ClickShield } from "./modal.styles";

const ModalClickShield = styled(ClickShield)`
cursor: pointer;
display: flex;
justify-content: center;
align-items:center;
z-index:10001;
}
`;

const Modal = styled.div`
  background: #f2f4f7;
  border-radius: 3px;
  width: ${(props) => (props.width ? props.width : "60%")};
  height: ${(props) => (props.height ? props.height : "95vh")};
  cursor: auto;
  z-index: 10002;
  font-size: 0.75rem;
  box-shadow: 0px 8px 10px rgba(50, 50, 50, 0.25),
    -10px 8px 15px rgba(50, 50, 50, 0.25), 10px 8px 15px rgba(50, 50, 50, 0.25);
  @media (max-width: 737px) {
    height: 90vh;
    width: 95vw;
  }
`;

class BaseModal extends React.Component {
  onHideClick = (e) => {
    this.props.onHideClick(e);
  };
  stopPropagation = (e) => {
    e.stopPropagation();
  };
  /* As per spec click outside modal should saves instead of cancel! */
  render() {
    const { height, width, styles } = this.props;
    return (
      <React.Fragment>
        <ModalClickShield onClick={this.onHideClick}>
          <Modal
            onClick={this.stopPropagation}
            height={height}
            width={width}
            style={styles}
          >
            {this.props.children}
          </Modal>
        </ModalClickShield>
      </React.Fragment>
    );
  }
}
export default BaseModal;



// WEBPACK FOOTER //
// ./src/components/Modals/BaseModal.js